import { createReducer } from '@reduxjs/toolkit';
import { addBuilderStateCase } from '../../Global/ComponentState/ComponentStateReducer';
import { AuthPageState } from './AuthPageState';

const initialState: AuthPageState = {
  state: { current: 'loading' }
};
export const authPageReducer = createReducer<AuthPageState>(initialState, (builder) => {
  addBuilderStateCase(builder, 'AUTH_PAGE');
  builder.addCase;
});
